// extracted by mini-css-extract-plugin
module.exports = {"inputs_wrapper":"JoinMindTrust11_inputs_wrapper__DvN13"};